import type { ReactNode } from 'react';

import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import type {
  Tag,
  TextStyle,
} from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import STYLES from './SectionHeader.module.scss';

const cls = cssModules(STYLES);

type Props = {
  title: string | ReactNode;
  link?: string;
  onLinkClick?: () => void;
  className?: string;
  mainClassName?: string;
  viewMoreButton?: ReactNode;
  textStyle?: TextStyle;
  tagName?: Tag;
};
const SectionHeader = ({
  className,
  link,
  mainClassName,
  onLinkClick,
  tagName = 'h2',
  textStyle = TEXT_STYLES.xxxl,
  title,
  viewMoreButton,
}: Props) => (
  <div className={cls('SectionHeader', mainClassName)}>
    <BpkText
      className={cls('SectionHeader__title', className)}
      tagName={tagName}
      textStyle={textStyle}
    >
      {title}
    </BpkText>
    {link && onLinkClick && (
      <BpkButtonV2 type={BUTTON_TYPES.link} onClick={onLinkClick}>
        {link}
      </BpkButtonV2>
    )}
    {viewMoreButton}
  </div>
);

export default SectionHeader;
